import { render, staticRenderFns } from "./ConfigureSSO.vue?vue&type=template&id=293f35e3&"
import script from "./ConfigureSSO.vue?vue&type=script&lang=js&"
export * from "./ConfigureSSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports